// Editable placeholder contact / brand config.
// Update these values with the real business details when available.
export const site = {
  name: "Lotus Property Services",
  tagline: "Every Property Deserves to Bloom.",
  script: "We remove the mess. You enjoy the new.",
  phoneDisplay: "(302) 602-9151",
  phoneHref: "tel:+13026029151",
  email: "lotusjunkservice@gmail.com",
  serviceAreaShort: "Chester, PA & Delaware County",
  hours: "Monday – Saturday · 7AM – 7PM",
  location: "Chester, Pennsylvania",
  social: {
    facebook: "https://www.facebook.com/profile.php?id=61592805124955",
    instagram: "https://www.instagram.com/lotus.propertyservices",
    google: "#",
    yelp: "#",
  },
};
